// extracted by mini-css-extract-plugin
module.exports = {"wrap":"not-found-view__wrap___1mNui"};